module.exports = __webpack_public_path__ + "static/media/cross.64eaf2ee.svg";